import { Header } from "../../models/Header";
import {
  DATE_DEBUT_TOOLTIP,
  DATE_ENTREE_TOOLTIP,
  DATE_FIN_TOOLTIP,
  DATE_SORTIE_TOOLTIP,
  P2_JOUR_TOOLTIP,
  STATUT_TOOLTIP,
} from "./headerConstants";

export const acheteur: Header = {
  field: "secAcheteur",
  fieldLabel: "Acheteur",
  fieldFormat: "",
  isDisplayed: true,
  align: "",
  isAddOnly: false,
  isMutable: false,
  tooltip: "",
}

export const aVenir: Header = {
  field: "prod_num_a_venir",
  fieldLabel: "À venir",
  isDisplayed: true,
  tooltip: "",
  width: "100",
  customCell: "ZeroEmptyString",
  fieldFormat: "",
  align: "",
  isAddOnly: false,
  isMutable: false,
  customHeader: "",
};

export const categorie: Header = {
  field: "cat_descr",
  fieldLabel: "Catégorie",
  fieldFormat: "",
  isDisplayed: true,
  align: "",
  isAddOnly: false,
  isMutable: false,
  tooltip: "",
};

export const codeAct: Header = {
  field: "act_cd",
  fieldLabel: "Code Act",
  fieldFormat: "",
  isDisplayed: true,
  align: "",
  isAddOnly: false,
  isMutable: false,
  tooltip: "",
};

export const collection: Header = {
  field: "prod_collection",
  fieldLabel: "Collection",
  fieldFormat: "",
  isDisplayed: true,
  align: "",
  isAddOnly: false,
  isMutable: false,
  tooltip: "",
};

export const dateDebut: Header = {
  field: "plano_dt_deb",
  fieldLabel: "Date Début",
  fieldFormat: "",
  isDisplayed: true,
  align: "",
  isAddOnly: false,
  isMutable: false,
  tooltip: DATE_DEBUT_TOOLTIP,
  customHeader: "",
  customCell: "",
  width: "100",
};

export const dateEntree: Header = {
  field: "plano_trsf_dt_entree",
  fieldLabel: "Date Entrée",
  fieldFormat: "",
  isDisplayed: true,
  align: "",
  isAddOnly: false,
  isMutable: true,
  tooltip: DATE_ENTREE_TOOLTIP,
  customHeader: "",
  customCell: "",
  width: "100",
};

export const dateFin: Header = {
  field: "plano_dt_fin",
  fieldLabel: "Date Fin",
  fieldFormat: "",
  isDisplayed: false,
  align: "",
  isAddOnly: false,
  isMutable: false,
  tooltip: DATE_FIN_TOOLTIP,
  customHeader: "",
  customCell: "",
  width: "100",
};

export const dateSortie: Header = {
  field: "plano_trsf_dt_sortie",
  fieldLabel: "Date Sortie",
  fieldFormat: "",
  isDisplayed: true,
  align: "",
  isAddOnly: false,
  isMutable: false,
  tooltip: DATE_SORTIE_TOOLTIP,
  customHeader: "",
  customCell: "",
  width: "100",
};

export const departement: Header = {
  field: "dept_nom",
  fieldLabel: "Département",
  fieldFormat: "",
  isDisplayed: true,
  align: "",
  isAddOnly: false,
  isMutable: false,
  tooltip: "",
};

export const description: Header = {
  field: "mod_descr",
  fieldLabel: "Description",
  fieldFormat: "",
  isDisplayed: true,
  align: "",
  isAddOnly: false,
  isMutable: false,
  tooltip: "",
};

export const division: Header = {
  field: "div_nom",
  fieldLabel: "Division",
  fieldFormat: "",
  isDisplayed: true,
  width: "120",
  isAddOnly: false,
  isMutable: false,
  tooltip: " ",
};

export const fournisseur: Header = {
  field: "four_nom_aff",
  fieldLabel: "Fournisseur",
  fieldFormat: "",
  isDisplayed: true,
  align: "",
  isAddOnly: false,
  isMutable: false,
  tooltip: "",
};

export const gamme: Header = {
  field: "gamme_descr",
        fieldLabel: "Gamme",
        fieldFormat: "",
        isDisplayed: true,
        align: "",
        isAddOnly: false,
        isMutable: false
}

export const historique: Header = {
  field: "histo",
  fieldLabel: "Historique",
  fieldFormat: "",
  isDisplayed: false,
  align: "",
  isAddOnly: false,
  isMutable: false,
  tooltip: "",
  customHeader: "",
  customCell: "",
  width: "210",
};

export const indicateur: Header = {
  field: "",
  fieldLabel: "",
  fieldFormat: "",
  isDisplayed: true,
  align: "",
  isAddOnly: true,
  isMutable: false,
  tooltip: "",
  customHeader: "",
  customCell: "IndicateurCell",
  width: "35",
};

export const jrDemo: Header = {
  field: "nbr_jr_demo",
  fieldLabel: "Jr Démo",
  fieldFormat: "",
  isDisplayed: true,
  align: "",
  isAddOnly: false,
  isMutable: false,
  tooltip: "",
  customHeader: "",
  customCell: "",
  width: "100",
};

export const magasin: Header = {
  field: "mag_nom_aff",
  fieldLabel: "Magasin",
  fieldFormat: "",
  isDisplayed: true,
  align: "",
  isAddOnly: true,
  isMutable: false,
  tooltip: "",
  customHeader: "magasinsToggle",
  customCell: "",
  width: "150",
};

export const mode: Header = {
  field: "planss_mode_aff",
  fieldLabel: "Mode",
  fieldFormat: "",
  isDisplayed: true,
  align: "",
  isAddOnly: false,
  isMutable: false
}

export const modele: Header = {
  field: "mod_cd",
  fieldLabel: "Modèle",
  fieldFormat: "",
  isDisplayed: true,
  width: "200",
  isAddOnly: false,
  isMutable: false,
  tooltip: "",
};

export const nbMorceaux: Header = {
  field: "nbr_mcx",
  fieldLabel: "Nb. Mcx",
  fieldFormat: "",
  isDisplayed: false,
  width: "100",
  isAddOnly: false,
  isMutable: false,
  tooltip: "",
};

export const noSuccursale: Header = {
  field: "mag_num",
  fieldLabel: "No Succursale",
  fieldFormat: "{0:00}",
  isDisplayed: false,
  align: "",
  isAddOnly: true,
  isMutable: false,
  tooltip: "",
  customCell: "",
  width: "150",
};

export const ordre: Header = {
  field: "plans_ordre",
  fieldLabel: "Ordre",
  fieldFormat: "",
  isDisplayed: true,
  align: "",
  isAddOnly: false,
  isMutable: false
}

export const p2: Header = {
  field: "pcarre",
  fieldLabel: "P2",
  fieldFormat: "",
  isDisplayed: false,
  align: "",
  isAddOnly: false,
  isMutable: false,
  tooltip: "",
  customHeader: "",
  customCell: "",
  width: "100",
};

export const p2ParJour: Header = {
  field: "ventes_jr_p2",
  fieldLabel: "$ P2 / Jr",
  fieldFormat: "{0:c}",
  isDisplayed: false,
  align: "",
  isAddOnly: false,
  isMutable: false,
  tooltip: P2_JOUR_TOOLTIP,
  customHeader: "",
  customCell: "",
  width: "100",
};

export const planoPlateau: Header = {
  field: "plano_plateau",
  fieldLabel: "Plateau",
  fieldFormat: "",
  isDisplayed: true,
  isAddOnly: false,
  isMutable: false,
  tooltip: "",
  width: "150",
};

export const planoQte: Header = {
  field: "plano_qte",
  fieldLabel: "Quantité",
  fieldFormat: "",
  tooltip: "",
  isDisplayed: true,
  customCell: "",
  width: "100",
};

export const prendLaPlaceDe: Header = {
  field: "plano_prod_num_remp",
  fieldLabel: "Prend la place de",
  fieldFormat: "{0:0000000}",
  isDisplayed: true,
  align: "",
  isAddOnly: false,
  isMutable: true,
  tooltip: "",
  customHeader: "",
  customCell: "",
  width: "125",
};

export const prix: Header = {
  field: "prix_vente",
  fieldLabel: "Prix",
  fieldFormat: "{0:c}",
  isDisplayed: true,
  width: "120",
  isAddOnly: false,
  isMutable: false,
  tooltip: "",
};

export const produit: Header = {
  field: "prod_num",
  fieldLabel: "Produit",
  fieldFormat: "{0:0000000}",
  isDisplayed: true,
  align: "",
  isAddOnly: false,
  isMutable: false,
  tooltip: "",
};

export const qte: Header = {
  field: "planost_ventes_mcx",
  fieldLabel: "Qté",
  fieldFormat: "{0:n}",
  isDisplayed: true,
  align: "",
  isAddOnly: false,
  isMutable: false,
  tooltip: "",
  customHeader: "",
  customCell: "",
  width: "100",
};

export const qteMinEntrepot: Header = {
  field: "prodmin_qte_bs",
  fieldLabel: "Qté min. entrepôt",
  isDisplayed: true,
  tooltip: "",
  width: "200",
  fieldFormat: "",
  align: "",
  isAddOnly: false,
  isMutable: false,
  customHeader: "",
  customCell: "",
};

export const qteMinPlancher: Header = {
  field: "prodmin_qte_min",
  fieldLabel: "Qté min. plancher",
  isDisplayed: true,
  tooltip: "",
  width: "200",
  fieldFormat: "",
  align: "",
  isAddOnly: false,
  isMutable: false,
  customHeader: "",
  customCell: "",
};

export const reapprovisionnementAuto: Header = {
  field: "reappro_auto",
  fieldLabel: "Réapprovisionnement automatique",
  isDisplayed: true,
  tooltip: "",
  width: "150",
  customCell: "BooleanCell",
};

export const remplacer: Header = {
field: "plano_remplacer",
fieldLabel: "Remplacé",
isDisplayed: true,
customCell: "BooleanCell",
width: "100"
};

export const section: Header = {
  field: "plans_nom",
  fieldLabel: "Section",
  fieldFormat: "",
  isDisplayed: false,
  align: "",
  isAddOnly: true,
  isMutable: false,
  tooltip: "",
  customHeader: "",
  customCell: "",
  width: "150",
};

export const statut: Header = {
  field: "statut_aff",
  fieldLabel: "Statut",
  fieldFormat: "",
  isDisplayed: true,
  align: "",
  isAddOnly: false,
  isMutable: false,
  tooltip: STATUT_TOOLTIP,
  customHeader: "",
  customCell: "StatutCell",
  width: "150",
};

export const style: Header = {
  field: "style_aff",
  fieldLabel: "Style",
  fieldFormat: "",
  isDisplayed: true,
  width: "150",
  isAddOnly: false,
  isMutable: false,
  tooltip: "",
};

export const surPlancher: Header = {
  field: "sur_plancher",
  fieldLabel: "Sur Plancher",
  fieldFormat: "",
  isDisplayed: true,
  align: "",
  isAddOnly: false,
  isMutable: false,
  tooltip: "",
  customHeader: "",
  customCell: "",
  width: "125",
};

export const ventes: Header = {
  field: "planost_ventes",
  fieldLabel: "Ventes $",
  fieldFormat: "{0:c}",
  isDisplayed: true,
  align: "",
  isAddOnly: false,
  isMutable: false,
  tooltip: "",
  customHeader: "",
  customCell: "",
  width: "150",
};
